export default __webpack_public_path__ + "fc65913bd503471ae8a9cea64928b654.svg";